module.exports = __webpack_public_path__ + "static/media/17-dark.c4f79cad.png";